import styled from "styled-components";
import { Link } from "react-router-dom";

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <Wrap>
      <Inner>
        <TopRow>
          <Block>
            <BrandTitle>CatchingGoldDiggers</BrandTitle>
            <BrandDesc>
              Premium adult streaming. Private, secure, and curated.
            </BrandDesc>

            <SupportLine>
              Support:{" "}
              <SupportLink href="mailto:support@catchinggolddiggers.com">
                support@catchinggolddiggers.com
              </SupportLink>
            </SupportLine>

            <Badges>
              <Badge>18+</Badge>
              <Badge>Privacy First</Badge>
              <Badge>Secure Billing</Badge>
            </Badges>
          </Block>

          <Cols>
            <Col>
              <ColTitle>Platform</ColTitle>
              <ColLink as={Link} to="/">Home</ColLink>
              <ColLink as={Link} to="/faq">FAQ</ColLink>
            </Col>

            <Col>
              <ColTitle>Legal</ColTitle>
              <ColLink as={Link} to="/terms">Terms</ColLink>
              <ColLink as={Link} to="/privacy">Privacy</ColLink>
              <ColLink as={Link} to="/terms#refunds">Refunds</ColLink>
              <ColLink as={Link} to="/terms#cancellation">Cancellation</ColLink>
            </Col>

            <Col>
              <ColTitle>Compliance</ColTitle>
              <ColLink as={Link} to="/terms#billing-descriptor">Billing Descriptor</ColLink>
              <ColLink as={Link} to="/terms#report-content">Report Content</ColLink>
              <ColLink as={Link} to="/dmca">DMCA</ColLink>
              <ColLink as={Link} to="/2257">2257 Statement</ColLink>
            </Col>
          </Cols>
        </TopRow>

        <Divider />

        <BottomRow>
          <SmallText>© {year} Catching Gold Diggers. All rights reserved.</SmallText>

          <RightLinks>
            <MiniLink as={Link} to="/privacy">Privacy</MiniLink>
            <MiniDot>•</MiniDot>
            <MiniLink as={Link} to="/terms">Terms</MiniLink>
          </RightLinks>
        </BottomRow>

        <Disclaimer>
          Adults only. You must be 18+ to enter. By using this site you agree to
          our Terms and Policies.
        </Disclaimer>
      </Inner>
    </Wrap>
  );
};

export default Footer;

/* Styles */
const Wrap = styled.footer`
  background: #000;
  color: #fff;
  padding-top: 40px;
  padding-bottom: 34px;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
`;

const Inner = styled.div`
  padding-left: 80px;
  padding-right: 80px;

  @media (max-width: 868px) {
    padding-left: 35px;
    padding-right: 35px;
  }

  @media (max-width: 568px) {
    padding-left: 0;
    padding-right: 0;
  }
`;

const TopRow = styled.div`
  display: grid;
  grid-template-columns: 1.1fr 2fr;
  gap: 28px;

  @media (max-width: 868px) {
    grid-template-columns: 1fr;
  }
`;

const Block = styled.div`
  @media (max-width: 568px) {
    padding: 0 20px;
  }
`;

const BrandTitle = styled.div`
  font-size: 18px;
  font-weight: 800;
  margin-bottom: 8px;
`;

const BrandDesc = styled.div`
  font-size: 14px;
  color: rgba(255, 255, 255, 0.68);
  line-height: 1.4;
  margin-bottom: 14px;
  max-width: 420px;
`;

const SupportLine = styled.div`
  font-size: 13px;
  color: rgba(255, 255, 255, 0.78);
  line-height: 1.55;
  margin-bottom: 6px;
`;

const SupportLink = styled.a`
  color: rgba(255, 255, 255, 0.92);
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

const Badges = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 14px;
`;

const Badge = styled.span`
  font-size: 12px;
  color: rgba(255, 255, 255, 0.78);
  border: 1px solid rgba(255, 255, 255, 0.14);
  padding: 6px 10px;
  border-radius: 999px;
`;

const Cols = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;

  @media (max-width: 568px) {
    grid-template-columns: 1fr;
    padding: 0 20px;
  }
`;

const Col = styled.div``;

const ColTitle = styled.div`
  font-size: 14px;
  font-weight: 700;
  margin-bottom: 10px;
`;

const ColLink = styled(Link)`
  display: block;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.68);
  text-decoration: none;
  margin-bottom: 10px;

  &:hover {
    color: rgba(255, 255, 255, 0.92);
  }
`;

const Divider = styled.div`
  height: 1px;
  background: rgba(255, 255, 255, 0.08);
  margin: 26px 0;

  @media (max-width: 568px) {
    margin: 22px 20px;
  }
`;

const BottomRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media (max-width: 568px) {
    padding: 0 20px;
    flex-direction: column;
    gap: 12px;
    align-items: flex-start;
  }
`;

const SmallText = styled.div`
  font-size: 12px;
  color: rgba(255, 255, 255, 0.6);
`;

const RightLinks = styled.div`
  display: flex;
  align-items: center;
`;

const MiniLink = styled(Link)`
  font-size: 12px;
  color: rgba(255, 255, 255, 0.72);
  text-decoration: none;

  &:hover {
    color: rgba(255, 255, 255, 0.92);
  }
`;

const MiniDot = styled.span`
  margin: 0 10px;
  color: rgba(255, 255, 255, 0.35);
`;

const Disclaimer = styled.div`
  margin-top: 18px;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.55);
  line-height: 1.5;
  max-width: 900px;

  @media (max-width: 568px) {
    padding: 0 20px;
  }
`;
